import axios, {AxiosResponse} from 'axios'
import { ID, Response } from '../../_dashboard/helpers'
import dataAxios from '../modules/auth/core/dataAxios'
import formDataAxios from '../modules/auth/core/formDataAxios'

const API_URL = process.env.REACT_APP_API_URL|| ''
const I18N_CONFIG_KEY = process.env.REACT_APP_I18N_CONFIG_KEY || 'i18nConfig';

const ls = localStorage.getItem(I18N_CONFIG_KEY) || '{"selectedLang":"fr"}'; // Récupère la valeur de localStorage
const config = JSON.parse(ls); // Convertit la chaîne JSON en objet
const selectedLang = config.selectedLang;
interface DeleteResponse {
  payload?: {
    code?: number;
  };
}

// Middleware to apply translation if language param is present
function applyTranslationMiddleware(response: any, language: string): any {
  // Liste avec toutes langues ("all") ou vide : ne pas fusionner (évite des listes vides / data corrompues)
  if (!language || language === 'all') return response;

  // Helper to apply translation to a single object, recursively
  const applyToObject = (obj: any): any => {
    if (!obj || typeof obj !== 'object') return obj;

    // Special handling for contentCategoriesByType
    if (obj.contentCategoriesByType) {
      
      Object.keys(obj.contentCategoriesByType).forEach(type => {
        
        if (Array.isArray(obj.contentCategoriesByType[type])) {
          obj.contentCategoriesByType[type] = obj.contentCategoriesByType[type].map((category: any) => {
            
            if (category.details && Array.isArray(category.details)) {
              category.details = category.details.map((detail: any) => {
                
                if (detail.translations && Array.isArray(detail.translations)) {
                  const translation = detail.translations.find((t: any) => t.language === language);
                  
                  if (translation) {
                    const updatedDetail = {
                      ...detail,
                      title: translation.title,
                      description: translation.description
                    };
                    return updatedDetail;
                  }
                }
                return detail;
              });
            }
            return category;
          });
        }
      });
      
    }

    // Recursively apply to all object properties and arrays
    Object.keys(obj).forEach(key => {
      if (Array.isArray(obj[key])) {
        obj[key] = obj[key].map((item: any) => applyToObject(item));
      } else if (obj[key] && typeof obj[key] === 'object') {
        obj[key] = applyToObject(obj[key]);
      }
    });

    // Now apply translation if present
    if (obj.translations && Array.isArray(obj.translations)) {
      const translation = obj.translations.find((t: any) => t.language === language);
      if (translation) {
        // Never overwrite parent document identifiers / relation keys from translation docs.
        // HotelTranslation.hotel_id stores the Hotel Mongo _id — copying it would wipe the
        // external API hotel_id on list/detail responses.
        const skipKeys = new Set([
          'language',
          '_id',
          'id',
          '__v',
          'tour_id',
          'hotel_id',
          'theme_id',
          'facility_id',
          'option_id',
          'category_id',
          'page_id',
          'blog_id',
          'seoSlug',
          'createDate',
          'updateDate',
          'createdAt',
          'updatedAt',
        ])
        Object.keys(translation).forEach(key => {
          if (!skipKeys.has(key)) {
            obj[key] = translation[key];
          }
        });
      }
    }

    return obj;
  };

  const result = applyToObject(response);
  return result;
}

const getAll = (query: any, URL: string): Promise<any> => {
  return dataAxios
    .get(`${API_URL + URL}`, { params: { ...query } })
    .then((d: any) => d.data)
    .then(data => applyTranslationMiddleware(data, query?.language));
}

const getOneById = (id: ID,URL:String): Promise<any | undefined> => {
  return dataAxios
    .get(`${API_URL+URL}/${id}`, {
      params: { language: selectedLang },
    })
    .then((response: AxiosResponse<Response<any>>) => response.data)
    .then((response: Response<any>) => response.data)
    .then(data => applyTranslationMiddleware(data, selectedLang));
}

const getOneByIdbylang = (URL:String): Promise<any | undefined> => {
  return dataAxios
    .get(`${API_URL+URL}`, {
    })
    .then((response: AxiosResponse<Response<any>>) => response.data)
    .then((response: Response<any>) => {
      const urlParams = new URLSearchParams(URL.split('?')[1]);
      const language = urlParams.get('language') || selectedLang;
      return applyTranslationMiddleware(response.data, language);
    });
}

const createOne = (data: any, URL: string): Promise<any | undefined> => {
  const isForm = typeof FormData !== 'undefined' && data instanceof FormData
  const client = isForm ? formDataAxios : dataAxios
  const config =
    isForm
      ? { headers: { 'Content-Type': undefined as unknown as string } }
      : undefined
  return client
    .post(API_URL + URL, data, config as object)
    .then((response: AxiosResponse<Response<any>>) => response.data)
    .then((response: Response<any>) => response)
    .catch((error) => {
      if (error.name === 'CanceledError' || error.message === 'canceled' || error.message.includes('aborted')) {
        return null;
      }
      throw error;
    });
}

const updateOne = (user: any, URL: String): Promise<any | undefined> => {
  return dataAxios
    .patch(`${API_URL+URL}`, user)
    .then((response: AxiosResponse<Response<any>>) => response.data)
    .then((response: Response<any>) => response)
}

const putOne = (body: any, URL: string): Promise<any | undefined> => {
  return dataAxios
    .put(`${API_URL + URL}`, body)
    .then((response: AxiosResponse<Response<any>>) => response.data)
    .then((response: Response<any>) => response)
}

const patchOne = (user: any, URL: String): Promise<any | undefined> => {
  const isForm = typeof FormData !== 'undefined' && user instanceof FormData
  const client = isForm ? formDataAxios : dataAxios
  const config =
    isForm
      ? { headers: { 'Content-Type': undefined as unknown as string } }
      : undefined
  return client
    .patch(`${API_URL + URL}`, user, config as object)
    .then((response: AxiosResponse<Response<any>>) => response.data)
    .then((response: Response<any>) => response)
    .catch((error) => {
      if (error.name === 'CanceledError' || error.message === 'canceled' || error.message.includes('aborted')) {
        return null;
      }
      throw error;
    });
}

const updatewithtranslation = (user: any,URL:String): Promise<any | undefined> => {
  return dataAxios
    .patch(`${API_URL+URL}`)
    .then((response: AxiosResponse<Response<any>>) => response.data)
    .then((response: Response<any>) => response.data)
}

const deleteOne = (userId: ID, URL: string): Promise<DeleteResponse> => {
  return dataAxios
    .delete(`${API_URL + URL}/${userId}`)
    .then((response: AxiosResponse<DeleteResponse>) => response.data);
};

const deleteSelectedOne = (userIds: Array<ID>,URL:String): Promise<void> => {
  const requests = userIds.map((id) => axios.delete(`${API_URL+URL}/${id}`))
  return axios.all(requests).then(() => {})
}

export {
  getAll,
  deleteOne,
  deleteSelectedOne,
  getOneById,
  createOne,
  updateOne,
  putOne,
  patchOne,
  updatewithtranslation,
  getOneByIdbylang,
}
